export const Bio = {
    name: "Stefewn Johnson",
    roles: [
      "Software Engineer",
      "Full Stack Developer",
      "ML Engineer",
      "Data Engineer",
      "AI Engineer",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/StefewnJohnson",
    resume:
      "https://drive.google.com/file/d/1dxoNAgwGSv8gSpxVOBRiWPtL5zVpfMmz/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/stefewn-johnson/",
  };
  
  export const skills = [
    {
      title: "Languages",
      skills: [
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
        },
        {
          name: "TypeScript",
          image:
            "https://static.vecteezy.com/system/resources/thumbnails/060/194/946/small/typescript-programming-language-3d-icon-transparent-background-free-png.png",
        },
        {
          name: "C",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/1/18/C_Programming_Language.svg",
        },
        {
          name: "C++",
          image:
            "https://www.vikingsoftware.com/wp-content/uploads/2024/02/C-2.png",
        },
        {
          name: "SQL",
          image:
            "https://db.cs.uni-tuebingen.de/teaching/ws2223/sql-is-a-programming-language/logo.svg",
        },
        {
          name: "Bash",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Bash_Logo_black_and_white_icon_only.svg/250px-Bash_Logo_black_and_white_icon_only.svg.png",
        },
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg",
        },
      ],
    },
    {
      title: "Tools & Platforms",
      skills: [
        {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
        name: "Postman",
        image:
          "https://www.svgrepo.com/show/354202/postman-icon.svg",
        },
        {
          name: "Visual Studio Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg",
        },
        //{
          //name: "Android",
          //image:
            //"https://pngimg.com/d/android_logo_PNG17.png",
        //},
        {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
        },
        {
          name: "Linux (Ubuntu)",
          image: "https://pngimg.com/d/linux_PNG1.png",
        },
        {
          name: "Jupyter Notebook",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1200px-Jupyter_logo.svg.png",
        },
        {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
        },
        {
          name: "Google Colab",
          image:
            "https://avatars.githubusercontent.com/u/33467679?s=280&v=4",
        },
      ],
    },
    {
      title: "Frameworks & Libraries",
      skills: [
        {
          name: "React.js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "React Native",
          image:
            "https://cdn.iconscout.com/icon/free/png-256/free-react-logo-icon-svg-download-png-2945110.png",
        },
        {
          name: "Next.js",
          image:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
        },
        {
        name: "Node.js",
        image: "https://nodejs.org/static/images/logo.svg",
        },
        {
        name: "Express.js",
        image:
          "data:image/png;base64,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",
        },
        {
          name: "Spring Boot",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/7/79/Spring_Boot.svg",
        },
        {
          name: "OpenCV",
          image:
            "https://raw.githubusercontent.com/wiki/opencv/opencv/logo/OpenCV_logo_no_text.png",
        },
      ],
    },
    {
      title: "Databases & Cloud / DevOps",
      skills: [
        {
          name: "PostgreSQL",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/2/29/Postgresql_elephant.svg",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "SQLite",
          image:
            "https://cdn3d.iconscout.com/3d/free/thumb/free-sqlite-3d-icon-png-download-7578006.png?f=webp",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Microsoft Access",
          image:
            "https://1000logos.net/wp-content/uploads/2020/08/Microsoft-Access-Logo.png",
        },
        {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
        {
          name: "Render",
          image:
            "https://images.crunchbase.com/image/upload/c_pad,f_auto,q_auto:eco,dpr_1/gkq3dkkfkec8edd6fuay?ik-sanitizeSvg=true",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://www.theglobeandmail.com/resizer/hMhEz1i79KAmXvteNAmF1Es34jc=/arc-anglerfish-tgam-prod-tgam/public/6KE3L65AFNDBJAMVBXZY6ZQGCE.JPG",
      role: "Programmer/Analyst Co-op",
      company: "TTC, Toronto, ON",
      date: "May 2025 - Aug 2025",
      desc: "Built a maintenance system and database in Microsoft Access, enabling admin users to issue maintenance notices. Rebuilt TTC’s old Microsoft Access forms and reports using HTML, CSS, and JavaScript for better functionality and UI. Developed an employee database in Microsoft Access to streamline the process of updating TTC employee information, using SQL and VBA to reduce the task to a two-button operation. Engineered a calendar application using HTML, CSS, and JavaScript, displaying historical and current train service data for each day, peak, and train line for TTC staff.",
      skills: [
        "SQL",
        "HTML",
        "CSS",
        "JavaScript",
        "Visual Basic for Applications (VBA)",
        "Microsoft Access",
        "Ultra Edit",
      ],
      //doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
    },
    {
      id: 1,
      img: "https://pbs.twimg.com/profile_images/1306241109924950018/4n0WOra7_400x400.jpg",
      role: "Head Soccer Coach",
      company: "Thornhill Soccer Club, Thornhill, ON",
      date: "May 2023 - Oct 2025",
      desc: "Meticulously craft session plans for training sessions and effectively organize teams to secure victories. Take charge of cleaning and maintaining the sports area, ensuring a safe and welcoming environment for all. Facilitate the development of players' technical skills and soccer knowledge through focused training and mentorship. Cultivate strong leadership, control, and planning skills essential for driving team performance and success.",
      skills: [
        "Communication",
        "Leadership",
        "Teamwork",
        "Organization Skills",
        "Time Management",
        "Coaching",
      ],
      //doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
    },
    {
      id: 2,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQiXAsA6tjbgJ30S0yxSapjiUCgheDWmVAEw&s",
      role: "Sports Attendant",
      company: "City of Vaughan",
      date: "Apr 2022 - June 2025",
      desc: "Teach children various sports, prioritizing their enjoyment and safety in a positive and supportive environment. Take responsibility for cleanliness and maintenance of sports area, ensuring safe and hygienic space for activities. Hone strong verbal communication and interpersonal skills, effectively engaging with children and colleagues. Develop solid organizational skills to manage tasks efficiently. Cultivate collaborative skills by working closely with teams, contributing to a cohesive and effective team dynamic.",
      skills: [
        "Communication",
        "Interpersonal Skills",
        "Teaching",
        "Safety Awareness",
        "Risk Management",
      ],
    },
    {
      id: 3,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8rHrGdb-8ROOm1Y0iaZQ7fczblKh4mqab_Q&s",
      role: "Research Assistant (Machine Learning)",
      company: "York University, North York, ON",
      date: "May 2024 - August 2024",
      desc: "Built a GPT-2 model in Python to predict emotions in conversational text using sequence modeling. Trained and fine-tuned the model on the DailyDialog dataset, including data preprocessing, tokenization, and a labeled text classification task. Assessed model performance on emotion prediction tasks, like happy, sad, or angry, using classification accuracy.",
      skills: [
        "Python",
        "Model Training and Fine-Tuning",
        "Machine Learning",
        "Deep Learning",
        "Natural Language Processing (NLP)",
        "PyTorch",
        "Data Preparation",
        "Text Classification",
      ],
      //doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
    {
      id: 4,
      img: "https://www.theglobeandmail.com/resizer/hMhEz1i79KAmXvteNAmF1Es34jc=/arc-anglerfish-tgam-prod-tgam/public/6KE3L65AFNDBJAMVBXZY6ZQGCE.JPG",
      role: "Graphic Designer",
      company: "TTC, Toronto, ON",
      date: "May 2023 - August 2023",
      desc: "Managed and cleaned up images using Photoshop, and then published them on their website. Used Microsoft Outlook to email clients if they are interested in ordering ride guides. Utilized Microsoft PowerPoint to make a presentation on Black History Month and Black Indigenous Month. Leveraged Microsoft Excel to manage client information about ride guides.",
      skills: [
        "Software Design",
        "User Experience (UX)",
        "Online Graphics",
        "Image Design",
        "Adobe Photoshop",
        "WordPress",
        "Microsoft Office",
      ],
      //doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8rHrGdb-8ROOm1Y0iaZQ7fczblKh4mqab_Q&s",
      school: "York University, North York, ON",
      date: "Sep 2022 - Apr 2026",
      grade: "7.0/9.0 GPA",
      desc: "Activities and societies: I am currently enrolled in the prestigious Bergeron Entrepreneurs in Science and Technology certification program. This unique program combines courses from the esteemed Lassonde School of Engineering, Schulich School of Business, and Osgoode Hall Law School. It offers a comprehensive blend of technical expertise, business acumen, and legal understanding, preparing me to excel in the dynamic intersection of science, technology, and entrepreneurship.",
      degree: "Specialized Honours Bachelor of Science, Computer Science",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS4mbIzvW76PTadcpcO-RLCC4e-VwcShkfQ7Q&s",
      school: "Cardinal Carter High School, Aurora, ON",
      date: "Sep 2018 - Jun 2022",
      grade: "95.0%",
      desc: "Activities and societies: Deca Club | Soccer Club | Stock Club",
      degree: "High School Diploma",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "AI News Aggregator",
      date: "Dec 2025 - Jan 2026",
      description:
        "Built an end-to-end GenAI pipeline that aggregates AI news from YouTube and RSS feeds, processes content with LLM-powered summarization, relevance ranking, and personalized digest generation. Designed a modular backend architecture with scrapers, processing services, and agents, persisting data in PostgreSQL and orchestrating daily production runs. Deployed the containerized system using Docker with scheduled execution on Render in a production environment.",
      image:
        "https://media.licdn.com/dms/image/v2/D5612AQGyilbRtwjQ9A/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1729524506512?e=2147483647&v=beta&t=3esmjfAon5tTXhVzY9uXqLlv74-FgXRvlCR-VwMCZrk",
      tags: ["AI / Machine Learning", "LLM", "Web Scraping", "PostgreSQL", "Docker"],
      category: "ai/machine learning",
      webapp: "https://github.com/StefewnJohnson/AI-News-Aggregator",
    },
    {
      id: 1,
      title: "Kuik",
      date: "Sep 2025 - Dec 2025",
      description:
        "Collaboratively built and deployed a Spring Boot backend using MVC architecture, exposing RESTful APIs with transactional business logic; Dockerized and deployed on Render. Designed a normalized PostgreSQL schema with core entities, enum-based order states, and stock-safe checkout logic, ensuring data integrity. Developed a React frontend with Redux state management, protected routes, and JWT-based API integration for secure end-to-end communication.",
      image:
        "https://media.istockphoto.com/id/1414126704/vector/online-shopping-concept.jpg?s=612x612&w=0&k=20&c=crMSuH56xz0OwOU9aD9WruiACBWyZY_TOnbG4hQaXec=",
      tags: ["Spring Boot", "React", "Redux", "REST APIs", "PostgreSQL"],
      category: "full-stack",
      webapp: "https://github.com/StefewnJohnson/Kuik",
    },
    {
      id: 2,
      title: "Sharelyst",
      date: "Sep 2025 - Nov 2025",
      description:
        "Collaboratively built a React Native (Expo) frontend with intuitive UI and seamless user interaction. Built a secure Node.js/Express backend with SQLite, JWT authentication, validation middleware, and RESTful routes for users, groups, and transactions. Deployed the full stack on Render, ensuring production-ready performance and environment consistency.",
      image:
        "https://avatars.githubusercontent.com/u/237477365?s=200&v=4",
      tags: ["React Native / Expo", "Node.js / Express", "Mobile App Development", "SQLite / Databases", "JWT Authentication / Security"],
      category: "mobile",
      webapp: "https://github.com/StefewnJohnson/Sharelyst",
    },
    {
      id: 3,
      title: "Weather App",
      date: "Jul 2024 - Aug 2024",
      description:
        "Developed a Java application that provides real-time weather information of the user-entered location, including weather conditions, wind speed, humidity, and temperature, using Java API Calls. Ensures flawless interaction between the GUI and the external weather source using backend logic to extract weather data and geographic coordinates of a specific location.",
      image:
        "https://raw.githubusercontent.com/StefewnJohnson/Weather-App-GUI/refs/heads/main/Weather%20App%20GUI%20ScreenShot.png",
      tags: ["Java", "Application Development", "API Integration", "Graphical User Interface (GUI)", "Problem-Solving & Debugging"],
      webapp: "https://github.com/StefewnJohnson/Weather-App-GUI",
    },
    {
      id: 4,
      title: "Edify",
      date: "Oct 2023 - Jan 2024",
      description:
        "Spearheaded the creation of Edify, an innovative AI-driven online learning platform aligned with the UN Sustainability Goal for Quality Education. Designed to cater to individual learning styles while ensuring privacy and safety for children, Edify leverages predictive analytics and collaboration tools for a personalized educational experience. Led a diverse team of experts in web design, graphic design, game development, web development, AI, and machine learning to develop an inclusive and effective learning environment.",
      image:
        "https://raw.githubusercontent.com/StefewnJohnson/stefewnjohnson.github.io/main/src/images/Screen%20Shot%202024-07-24%20at%209.56.26%20AM.png",
        //"https://edifylearning.github.io/EdifyWebsite/assets/img/Logo%20Edify%20(11)%20(1).png",
      tags: ["HTML", "CSS", "JavaScript", "Visual Studio Code", "Web Development"],
      category: "website",
      webapp: "https://edifylearning.github.io/EdifyWebsite/",
    },
  ];
  
  export const TimeLineData = [
    { year: 2017, text: "Started my journey" },
    { year: 2018, text: "Worked as a freelance developer" },
    { year: 2019, text: "Founded JavaScript Mastery" },
    { year: 2020, text: "Shared my projects with the world" },
    { year: 2021, text: "Started my own platform" },
  ];
